import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';
import { useState } from 'react';
import { Footer } from '@/components/layouts/Footer';
import { Header } from '@/components/layouts/Header';
import { NewsletterDialog } from '@/components/marketing/NewsletterDialog';
import { useApollo } from '@/config/apollo';
import '@/styles/globals.css';

const CustomApp = ({ Component, pageProps }: AppProps) => {
  const apolloClient = useApollo(pageProps);

  // Show the newsletter modal by default; can be enhanced with localStorage logic
  const [showNewsletter, setShowNewsletter] = useState(true);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <ApolloProvider client={apolloClient}>
        <Component {...pageProps} />
      </ApolloProvider>
      <NewsletterDialog open={showNewsletter} onOpenChange={setShowNewsletter} />
      <Footer />
    </div>
  );
};

export default CustomApp;
